import { t } from 'i18next';
import ShiftTimePicker from './ShiftTimePicker';
import DeleteScheduleModal from './Modals/DeleteScheduleModal';
import AddNewWorkshift from './Modals/AddNewWorkshift';
import UpdateSchedule from './Modals/UpdateSchedule';
import FunctionalitySchedule from '../../Functionality/FunctionalityShedule';
import { permissionObj } from '../../../../../../Helpers/permission';
import DividerWithText from '../../../../../../components/DividerWithText';
import React from 'react';
import { EditIcon, TrashOutlineIcon } from '../../../../../../components/buttons/IconButtons';
import ButtonIcon from "../../../../../../components/buttons/ButtonIcon";
import NotInformation from '../../../../../../components/NotInformation';
import CustomButtonLink from '../../../../../../components/buttons/CustomButtonLink';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const ScheduleSection = (
    {
        registerAction
    }
) => {

    //function to get the functionality of schedule section
    const {
        searchResults,
        handleCreate,
        handleUpdate,
        handleRemoveSchedule,
        showDeleteModal,
        setShowDeleteModal,
        showCreateModal,
        setShowCreateModal,
        showUpdatedModal,
        setShowUpdatedModal,
        dataUpdate,
        selectedIds,
        DEV,
        permission,
        setModified,
    } = FunctionalitySchedule({registerAction});

    return (
        <>
            <div className="row px-0">
                <DividerWithText spacing='px-0' title={t('department_schedule')} />

                {searchResults?.length > 0 ?
                    <>
                        {searchResults?.map((item, index) => (
                            <>
                                <div className='d-flex justify-content-between align-items-center my-4'>
                                    <h5 className='ibl-h5-general-950 ibl-font-w-600'>{`${t('privileges')} ${(index + 1).toString().padStart(2, '0')}`}</h5>
                                    <div className='d-flex align-items-center gap-3 align-self-stretch'>
                                        {((DEV || permission?.includes(permissionObj?.WEB_ATTENDANCE_DEPARTMENT_POLICIES_UPDATE))) &&
                                            <ButtonIcon
                                                id='btn_ss1d_clean_form'
                                                Icon={EditIcon}
                                                title={'update'}
                                                iconProps='btn-icon-svg-12px icon-color-general-00'
                                                onClick={(e) => {
                                                    handleUpdate(item)
                                                }}
                                            />
                                        }

                                        {((DEV || permission?.includes(permissionObj?.WEB_ATTENDANCE_DEPARTMENT_POLICIES_DELETE)) && item?.departmentId != null) &&
                                            <ButtonIcon
                                                id='btn_ss1d_clean_form'
                                                Icon={TrashOutlineIcon}
                                                className='btn-icon-delete'
                                                iconProps='btn-icon-svg-12px icon-color-general-00'
                                                title={'delete'}
                                                onClick={(e) => {
                                                    handleRemoveSchedule(item)
                                                }}
                                            />
                                        }
                                    </div>
                                </div>

                                <div className='row px-0'>
                                    <ShiftTimePicker
                                        startShiftAt={item.startShiftAt}
                                        endShiftAt={item.endShiftAt}
                                        range={item.range ?? 0}
                                        selectedDepartment={item.departmentId}
                                        readOnly={true}
                                    />
                                </div>
                            </>
                        ))}
                    </>
                    :
                    <div className='mt-4'>
                        <NotInformation>
                            <div className={"warning-text"}>
                                <p>{t("you_have_not_created_department_schedule_yet")}</p>
                            </div>
                            {(DEV || permission?.includes(permissionObj?.WEB_ATTENDANCE_DEPARTMENT_POLICIES_CREATE)) &&
                                <CustomButtonLink
                                    splitName={false}
                                    id={'btn_ss_create_department'}
                                    card={true}
                                    onClick={(e) => {
                                        handleCreate(e)
                                    }}
                                    name={'create_new_department_schedule'} />
                            }
                        </NotInformation>
                    </div>
                }

            </div>

            {showDeleteModal && (
                <DeleteScheduleModal
                    show={showDeleteModal}
                    onHide={() => setShowDeleteModal(false)}
                    selectedIds={selectedIds}
                    setModified={setModified}
                />
            )}

            {showCreateModal && (
                <AddNewWorkshift
                    show={showCreateModal}
                    onHide={() => setShowCreateModal(false)}
                    setModified={setModified}
                />
            )}

            {showUpdatedModal && (
                <UpdateSchedule
                    show={showUpdatedModal}
                    onHide={() => setShowUpdatedModal(false)}
                    setModified={setModified}
                    dataUpdate={dataUpdate}
                />
            )}
        </>
    );
};

export default ScheduleSection;
